import { z } from "zod";

import { LIMITS } from "../constants.js";
import {
  addressObjectSchema,
  attachmentIdSchema,
  draftIdSchema,
  isoUtcSchema,
  mailboxIdSchema,
  pageInfoSchema,
} from "./common.js";

const recipientsSchema = z.array(addressObjectSchema).max(LIMITS.maxRecipientsPerMessage);

export const draftSchema = z.object({
  id: draftIdSchema,
  mailboxId: mailboxIdSchema,
  to: recipientsSchema,
  cc: recipientsSchema,
  bcc: recipientsSchema,
  subject: z.string().max(LIMITS.maxSubjectLength),
  text: z.string().max(LIMITS.maxTextBodyBytes),
  html: z.string().max(LIMITS.maxHtmlBodyBytes).nullable(),
  attachmentIds: z.array(attachmentIdSchema),
  version: z.number().int().positive(),
  createdAt: isoUtcSchema,
  updatedAt: isoUtcSchema,
});
export type Draft = z.infer<typeof draftSchema>;

export const listDraftsResponseSchema = z.object({
  drafts: z.array(draftSchema),
  pageInfo: pageInfoSchema,
});
export type ListDraftsResponse = z.infer<typeof listDraftsResponseSchema>;

export const saveDraftRequestSchema = z.object({
  mailboxId: mailboxIdSchema,
  to: recipientsSchema.default([]),
  cc: recipientsSchema.default([]),
  bcc: recipientsSchema.default([]),
  subject: z.string().max(LIMITS.maxSubjectLength).default(""),
  text: z.string().max(LIMITS.maxTextBodyBytes).default(""),
  html: z.string().max(LIMITS.maxHtmlBodyBytes).nullable().default(null),
  attachmentIds: z.array(attachmentIdSchema).max(LIMITS.maxAttachmentsPerMessage).default([]),
  /** Optimistic-concurrency guard; rejects stale writes when supplied. */
  expectedVersion: z.number().int().positive().optional(),
});
export type SaveDraftRequest = z.infer<typeof saveDraftRequestSchema>;

export const sendDraftRequestSchema = z.object({
  expectedVersion: z.number().int().positive().optional(),
});
export type SendDraftRequest = z.infer<typeof sendDraftRequestSchema>;
